module.exports = __webpack_public_path__ + "052dc6649ad238e3437d2bf997edae29.svg";